module.exports = __webpack_public_path__ + "img/select-peoples-two.e2cd7174.png";